import { NextPage } from 'next';
import { AppMainLayoutWrapper } from '../../layouts/LayoutWithLeftDesktopNav/AppMainLayoutWrapper/AppMainLayoutWrapper';
import { AssetDetailByIdTitle } from '../../asset-details/pages/AssetDetailByIdIndexTitle';
import { AssetDetailTradeWrapper } from '../../layouts/AssetDetailTradeWrapper/AssetDetailTradeWrapper';
import { AssetDetailsControllerWithSuspense } from '../../asset-details/AssetDetailsControllerWithSuspense';
import { redirect } from 'next/navigation';
import { NEXT_ROUTES } from '@bts-web/utils-next-infrastructure';
import { AcceptOrder } from '../AcceptOrder/AcceptOrder';
import { getServerFeatureFlag } from '../../statsig/sdk/server';
import { getOrderById } from '../../common/gqlActions/getOrderById.action';

interface AcceptOrderBackwardsCompatibilityInterceptorProps {
  searchParams: Promise<Record<string, string | undefined>>;
}

const AcceptOrderBackwardsCompatibilityInterceptor: NextPage<
  AcceptOrderBackwardsCompatibilityInterceptorProps
> = async ({ searchParams }) => {
  const feature_hasOrdersEnabled = getServerFeatureFlag(
    'feature_hasOrdersEnabled',
  );

  if (!feature_hasOrdersEnabled) {
    redirect(NEXT_ROUTES.PORTFOLIO);
  }

  const { tradeOfferID } = await searchParams;

  if (!tradeOfferID) {
    redirect(NEXT_ROUTES.ERROR_GENERIC);
  }

  const orderResult = await getOrderById(tradeOfferID);

  if ('errors' in orderResult) {
    redirect(NEXT_ROUTES.ERROR_GENERIC);
  }

  const assetId = orderResult.data.asset?.id;

  if (!assetId) {
    redirect(NEXT_ROUTES.ERROR_GENERIC);
  }

  return (
    <AppMainLayoutWrapper
      OverWriteTitleElement={<AssetDetailByIdTitle assetId={assetId} />}
      settings={{
        hideDesktopFooter: true,
        hideTopBarTradeButton: true,
      }}
    >
      <AssetDetailTradeWrapper
        startFocusValue={true}
        hideMobile="assetElement"
        AssetDetailsContent={
          <AssetDetailsControllerWithSuspense assetId={assetId} />
        }
        TradeStateContent={<AcceptOrder order={orderResult.data} />}
      />
    </AppMainLayoutWrapper>
  );
};

export { AcceptOrderBackwardsCompatibilityInterceptor };
